import React from 'react';
import { pdf } from '../../../../../../../services/fileTypes/CommonMimeTypes';
import { LOGICAL_DELETED_TEXT } from '../../../../../../helper_components/logical_deleted_expedient/LogicalDeletedExpedient';

const ActionsRow = ({
  onSignClick,
  documentLink,
  onCommentsClick,
  onDeleteClick,
  onPreviewDocument,
  onClick,
  isSignedButtonDisabled = false,
  isDeleteButtonDisabled = false,
  fileType = '',
  onUsersAndPermissionsListClick,
  disabled = false,
}) => {
  const isAPdfFile = fileType === pdf;

  const downloadButton = (
    <button
      type="button"
      className="btn btn-info px-3 py-1"
      data-toggle="tooltip"
      title="Descargar documento"
      disabled={disabled}
    >
      <i className="fas fa-file-alt px-1"></i>
    </button>
  );

  return (
    <div
      className="d-flex justify-content-around "
      style={{ fontSize: '20px', gap: '5px' }}
      onClick={disabled ? undefined : onClick}
      title={disabled ? LOGICAL_DELETED_TEXT : undefined}
    >
      {disabled ? (
        downloadButton
      ) : (
        <a href={documentLink} download>
          {downloadButton}
        </a>
      )}
      {isAPdfFile && (
        <button
          style={{ color: 'white' }}
          type="button"
          className="btn btn-secondary px-2 py-1"
          data-toggle="tooltip"
          title="Visualizar documento"
          onClick={onPreviewDocument}
          disabled={disabled}
        >
          <i className="fas fa-eye px-2"></i>
        </button>
      )}
      <button
        type="button"
        className="btn btn-success px-2 py-1"
        onClick={onSignClick}
        data-toggle="tooltip"
        title="Firmar documento"
        disabled={disabled || isSignedButtonDisabled}
      >
        <i className="fas fa-pen px-2"></i>
      </button>
      <button
        type="button"
        className="btn btn-primary px-2 py-1"
        data-toggle="tooltip"
        title="Comentarios"
        onClick={onCommentsClick}
        disabled={disabled}
      >
        <i className="fas fa-comments px-2"></i>
      </button>
      <button
        type="button"
        className="btn btn-danger px-2 py-1"
        data-toggle="tooltip"
        title="Eliminar documento"
        onClick={onDeleteClick}
        disabled={disabled || isDeleteButtonDisabled}
      >
        <i className="fas fa-trash-alt px-2"></i>
      </button>
      <button
        type="button"
        className="btn btn-warning text-white"
        data-toggle="tooltip"
        title="Gestionar permisos"
        onClick={onUsersAndPermissionsListClick}
        disabled={disabled}
      >
        <i className="fas fa-eye"></i>
      </button>
    </div>
  );
};
export default ActionsRow;
